import React from 'react';

const Footer = () => {
  return (
    <footer className="footer dark-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-copy">
            <p>&copy; {new Date().getFullYear()} Captiveworks. All rights reserved.</p>
          </div>
          <div className="footer-links">
            <a href="#terms">Terms of Service</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
